// removed by extract-text-webpack-plugin
module.exports = {"objective":"Objectives--objective--3X","trackedStat":"Objectives--trackedStat--3y","completedObjective":"Objectives--completedObjective--3b","objectiveTrack":"Objectives--objectiveTrack--1g","objectiveText":"Objectives--objectiveText--2X","completed":"Objectives--completed--30"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Objectives/styles.styl
// module id = 802
// module chunks = 0